export type LegacyPackageContractRow = {
  packageId: string
  packageName: string
  counts: Record<string, number>
}

export const legacyPackageContractRows: LegacyPackageContractRow[] = [
  { packageId: 'PKG-MOCK-01', packageName: 'Mock 베이직 패키지', counts: { '2026-01': 2, '2026-02': 1, '2026-03': 3, '2026-05': 2, '2026-08': 1 } },
  { packageId: 'PKG-MOCK-02', packageName: 'Mock 스페셜 패키지', counts: { '2026-01': 1, '2026-04': 2, '2026-06': 1, '2026-07': 3, '2026-08': 2 } },
  { packageId: 'PKG-MOCK-03', packageName: 'Mock 성장 패키지', counts: { '2026-02': 2, '2026-03': 1, '2026-05': 1, '2026-07': 1 } },
]

export const legacyPackageContractGroups = ['Mock 그룹 A', 'Mock 그룹 B']
export const legacyPackageContractOffices = ['Mock 지점 01', 'Mock 지점 02']
export const legacyPackageContractYears = ['2021', '2022', '2023', '2024', '2025', '2026']
